import { USER_DATA_KEY } from "../../constants/AppConstants";
import { getDefaultBlog } from "./blogAction";
import { getBookmarks } from "./postAction";

const init = () => {
  return dispatch => {
    try {
    const loginData = JSON.parse(localStorage.getItem(USER_DATA_KEY));
      const { id: userId, token } = loginData;
      if (userId && token) {
        dispatch({ type: 'SET_LOGIN', payload: loginData });
        dispatch(getDefaultBlog(userId))
        dispatch(getBookmarks());
      }
    } catch (e) {
      
    }
  }
}

const reset = (post, blog, comm, tag, book, auth) => {
  return dispatch => {
    if (post) {
      dispatch({ type: 'RESET_POST_STATE' })
    }
    if (blog) {
      dispatch({ type: 'RESET_BLOG_STATE' })
    }
    if (comm) {
      dispatch({ type: 'RESET_COMM_STATE' })
    }
    if (tag) {
      dispatch({ type: 'RESET_TAG_STATE' })
    }
    if (book) {
      dispatch({ type: 'RESET_BOOK_STATE' })
    }
    if (auth) {
      dispatch({ type: 'RESET_AUTH_STATE' })
    }
  }
}

export { init, reset };

